export const apiConstants = {
  fetchGuide: 'mock-data/setup/guide.json',
  fetchTags: 'mock-data/tags.json',
  fetchArtefacts: 'mock-data/setup/artefacts.json',
  fetchArtefact: 'mock-data/setup/artefact.json',
  fetchArtifactUnit: 'mock-data/setup/artefactUnit.json',
};
